import { jsx as _jsx } from "react/jsx-runtime";
import classNames from "classnames";
export function TextArea({ className, ...rest }) {
    return (_jsx("textarea", { className: classNames(className, "cvr-control"), ...rest }));
}
